import { memo } from "react";

import Export2Excel from "./export-2-excel";

function Index({ search = "", setSearch, addModal, users = [] }) {
  return (
    <div className="row clearfix">
      <div className="col-lg-5 col-md-4 col-sm-6">
        <div className="input-group">
          <input
            type="text"
            className="form-control"
            placeholder="Name, Email, Address"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>
      <div className="col-lg-2 col-md-4 col-sm-12">
        <button
          type="button"
          className="btn btn-sm btn-success"
          onClick={() => addModal()}
        >
          Add User
        </button>
      </div>
      <div className="col-lg-5 col-md-6">
        {users?.length > 0 && <Export2Excel users={users} />}
      </div>
    </div>
  );
}

export default memo(Index);
